import { Redirect } from 'app/routx-router'

const Layout = () => <Redirect to='login' replace />
export const Component = Layout
export default Layout
